import { CalendarViewName } from '~/types'

export const CHANGE_VIEW = 'CHANGE_VIEW'
export const CHANGE_DATES = 'CHANGE_DATES'

export const changeView = (view: CalendarViewName) =>
  ({
    type: CHANGE_VIEW,
    payload: view,
  }) as const

export const changeDates = (start: string, end: string) =>
  ({
    type: CHANGE_DATES,
    payload: { start, end },
  }) as const
